// src/pages/ConfirmEmail.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Alert, Spinner } from "react-bootstrap";

const ConfirmEmail = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate("/properties");
    }, 4000); // Redirection après 4s

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <Container className="mt-5 text-center">
      <Alert variant="success">
        ✅ Votre adresse e-mail a été confirmée avec succès !
      </Alert>
      <p>Vous allez être redirigé vers votre tableau de bord...</p>
      <Spinner animation="border" variant="primary" className="mt-3" />
    </Container>
  );
};

export default ConfirmEmail;
